export default {
  selfUninstalled: false,
  events: null,
  picture: null,

  vAuto: null,
  vFeatures: null,
  vKraken: null,

  memberSince: null,

  logoAspectRatio: null,
  assetMap: {},
  collapseItems: {},
  currentSetupStep: -1,

  previewItems: null,
  currentPreviewType: 'product',

  previewChange: {
    amptheme: false,
    status: false,
    layout: false,
    language: false,
    review: false,
    analytics: false,
    social: false,
    menus: false,
    customcss: false
  },
  db: {
    amptheme: null,
    status: null,
    layout: null,
    language: null,
    review: null,
    analytics: null,
    social: null,
    menus: null,
    customcss: null
  },
  amptheme: null,
  settings: null,
  error: false,

  // v2
  shopObj: null,
  plan: false,
  eligibleForTrial: false,

  // loading states
  loading: false,
  saving: false,

  highlight: null
}
